import React from "react";
import Slider from "react-slick";
import carouselSettings from "../../../Home/carouselSettings";
import { RUTA_IMAGEN } from "../../../../utils/rutasFijas";

const SliderImagenes = ({
  producto = { destino: { imagenes: [] }, multimedia: [] },
}) => {

  const imagenesParaSlider = producto.destino.imagenes;
  imagenesParaSlider.shift();
  const imagenesProducto = producto.multimedia.filter(
    (m) => m.tipoArchivo === "I"
  );

  imagenesProducto.forEach(function (img) {
    imagenesParaSlider.push(img.url);
  });

  //const imagenes = props.imagenes;
  let settings = carouselSettings[3];
  settings.prevArrow = <SamplePrevArrow />;
  settings.nextArrow = <SampleNextArrow />;

  return (
    <div className="image-gallery col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
      <div
        id="imageGalleryCarousel"
        className="carousel slide"
        data-ride="carousel"
        data-interval="false"
      >
        <div className="carousel-inner">
          <Slider {...settings}>
            {imagenesParaSlider.map((imagen, index) => {
              return (
                <div key={index} className="carousel-item">
                  <img
                    className="d-block"
                    style={{ width: "100%", borderRadius: "20px" }}
                    src={RUTA_IMAGEN + "resultados/" + imagen}
                    alt="Imagen del destino seleccionado"
                  />
                </div>
              );
            })}
          </Slider>
        </div>
        {/*<a className="carousel-control-prev" href="#imageGalleryCarousel" role="button" data-slide="prev">
                <div className="overlay"><span className="carousel-control-prev-icon" aria-hidden="true"></span></div>
                <span className="sr-only">Anterior</span>
              </a>
              <a className="carousel-control-next" href="#imageGalleryCarousel" role="button" data-slide="next">
                <div className="overlay"><span className="carousel-control-next-icon" aria-hidden="true"></span></div>
                <span className="sr-only">Siguiente</span>
              </a>*/}
      </div>
    </div>
  );
};

export default React.memo(SliderImagenes);

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <a
      className="carousel-control-next"
      href="#imageGalleryCarousel"
      role="button"
      data-slide="next"
      onClick={onClick}
    >
      <div className="overlay">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
      </div>
      <span className="sr-only">Siguiente</span>
    </a>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <a
      className="carousel-control-prev"
      href="#imageGalleryCarousel"
      role="button"
      data-slide="prev"
      onClick={onClick}
    >
      <div className="overlay">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      </div>
      <span className="sr-only">Anterior</span>
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/components/Resultados/ListadoProducto/ProductoCuadro/SliderImagenes.js